export default "__VITE_ASSET__vNLXU_iq__"